import { FC, ReactElement } from 'react';
import { Flex, Tooltip } from '@gravity-ui/uikit';

type SimpleTextPopoverProps = {
    content: string;
    children: ReactElement;
};

export const SimpleTextTooltip: FC<SimpleTextPopoverProps> = ({ content, children }) => {
    return (
        <Tooltip openDelay={500} content={<Flex style={{ padding: '5px' }}>{content}</Flex>}>
            {children}
        </Tooltip>
    );
};
